import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENV } from "@app/constants/env"
import { DsvcntryEntity, MDGDataEntity } from '@feature/types/mdgdatalist.type';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getToken } from '@app/helpers/authProvider';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: ENV.BASE_API_URL +ENV.FINANCE_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    incomingArgs,
    api,
    extraOptions
) => {
    let args: string | FetchArgs = incomingArgs;

    // normalize string arg to object so we can set headers
    if (typeof args === 'string') {
        args = { url: args };
    }

    try {
        const token = await getToken(); // ensure this returns a non-empty string
        //const token = sessionStorage.getItem('accessToken'); // Replace 'authToken' with the actual key used in sessionStorage
        if (token) {
            const headers =
                (args as FetchArgs).headers instanceof Headers
                    ? (args as FetchArgs).headers
                    : new Headers((args as FetchArgs).headers);

            headers.set('Authorization', `Bearer ${token}`); // use standard casing
            (args as FetchArgs).headers = headers;
        }

        const result = await rawBaseQuery(args, api, extraOptions);

        // optional: retry once if unauthorized (adjust getToken refresh logic if available)
        if (result.error && result.error.status === 401 && token) {
            // If you have a refresh flow, invoke it here then retry.
            // const refreshed = await getRefreshedToken();
            // if (refreshed) { headers.set('Authorization', `Bearer ${refreshed}`); return rawBaseQuery(args, api, extraOptions); }
        }
        return result;
    } catch {
        return { error: { status: 500, data: 'Token retrieval failed' } } as any;
    }
};

export interface ApiResponse<T> {
    success: boolean
    message?: string
    data?: T
    error?: string
}

export const mdgsliceApi = createApi({
    reducerPath: 'mdgsliceApi',
    baseQuery: authBaseQuery,
    tagTypes: ['finance'],
    endpoints: (builder) => ({

        getMdgData: builder.query<MDGDataEntity[], number>({
            query: (userId) => ({
                url: `MdgData/GetMdgdata/${userId}`,
                method: 'GET',
            }),
            providesTags: ['finance'],
        }),
        getMdgDataById: builder.query<MDGDataEntity[], number>({
            query: (internal_ID) => ({
                url: `MdgData/GetMdgDataById/${internal_ID}`,
                method: 'GET',
            }),
            providesTags: ['finance'],
        }),
        getDsvcntry: builder.query<DsvcntryEntity[], number>({
            query: (internal_ID) => ({
                url: `MdgData/Getdsvcntry/${internal_ID}`,
                method: 'GET',
            }),
            providesTags: ['finance'],
        }),
        getcs: builder.query<DsvcntryEntity[], number>({
            query: (internal_ID) => ({
                url: `MdgData/Getcs/${internal_ID}`,
                method: 'GET',
            }),
            providesTags: ['finance'],
        }),


    }),
});

export const {
    useGetMdgDataQuery,
    useGetMdgDataByIdQuery,
    useGetDsvcntryQuery,
    useGetcsQuery

} = mdgsliceApi;
